<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M4.00084 7.42843C5.89438 7.42843 7.42941 5.8934 7.42941 3.99986C7.42941 2.10632 5.89438 0.571289 4.00084 0.571289C2.10729 0.571289 0.572266 2.10632 0.572266 3.99986C0.572266 5.8934 2.10729 7.42843 4.00084 7.42843Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.0006 7.42836C13.263 7.42836 14.2863 6.40501 14.2863 5.14265C14.2863 3.88028 13.263 2.85693 12.0006 2.85693C10.7382 2.85693 9.71484 3.88028 9.71484 5.14265C9.71484 6.40501 10.7382 7.42836 12.0006 7.42836Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M11.4286 10.2856H5.14286C4.51168 10.2856 4 10.7973 4 11.4285V14.2856C4 14.9168 4.51168 15.4285 5.14286 15.4285H11.4286C12.0598 15.4285 12.5714 14.9168 12.5714 14.2856V11.4285C12.5714 10.7973 12.0598 10.2856 11.4286 10.2856Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4297 11.4282V14.2854"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
